/* eslint-disable max-len */
import React from 'react'
import storyImageOne from '../../../assets/macpunks/macpunks-story-1.png'
import storyImageTwo from '../../../assets/macpunks/macpunks-story-2.png'
import storyImageThree from '../../../assets/macpunks/macpunks-story-3.png'
import storyImageFour from '../../../assets/macpunks/macpunks-story-4.png'

const Tiles = () => (
    <div className="tiles-wrapper" id="story">
        <div className="tiles-tiles">
            <div className="tiles-row-one tile-space">
                <div className="window-left">
                    <div className="window" id="system-window" data-is-open="data-is-open">
                        <div className="title-bar">
                            {' '}
                            <button className="close" type="button"><span className="hidden">Close</span></button>
                            <h1 className="title">Macpunks</h1>
                            <button className="resize" type="button"><span className="hidden">Resize</span></button>
                        </div>
                        <div className="details-bar">
                            <h5 className="subtitle" style={{ color: '#c8c4c4' }}>Trapped in the confines of a cryptic program</h5>
                        </div>
                        <div className="window__pane img-pane">
                            <img src={storyImageOne} alt="Black and white A.I generated jail cell" />
                        </div>
                    </div>
                </div>

                <div className="window-right">
                    <div className="window" id="system-window" data-is-open="data-is-open">
                        <div className="title-bar">
                            {' '}
                            <button className="close" type="button"><span className="hidden">Close</span></button>
                            <h1 className="title">Macpunks</h1>
                            <button className="resize" type="button"><span className="hidden">Resize</span></button>
                        </div>
                        <div className="details-bar">
                            <h5 className="subtitle">Trapped in the confines of a cryptic program</h5>
                        </div>
                        <div className="window__pane">
                            <p>The MacPunks tribe lay dormant for milenia. During the Thousand War between the Apple Rebellion and the Windows Hive Collective, the MacPunks tucked themselves away inside a cyber program in order to hide from the devastation between the two dangerous factions. Deep in their eternal hibernation, their now oppressors, a rogue Cyberpunks mob have taken advantage of the situation. They have imprisoned the MacPunks as a wellsource to dine upon their creativity and inspirational energies to empower their livelihood. All would have remained as had it not been an unexpected surprise.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="tiles-row-two tile-space">
                <div className="window-left">
                    <div className="window" id="system-window" data-is-open="data-is-open">
                        <div className="title-bar">
                            {' '}
                            <button className="close" type="button"><span className="hidden">Close</span></button>
                            <h1 className="title">Macpunks</h1>
                            <button className="resize" type="button"><span className="hidden">Resize</span></button>
                        </div>
                        <div className="details-bar">
                            <h5 className="subtitle" style={{ color: '#c8c4c4' }}>A sudden spark!</h5>
                        </div>
                        <div className="window__pane img-pane">
                            <img src={storyImageTwo} alt="A.I generated storm and lightning in clouds" />
                        </div>
                    </div>
                </div>

                <div className="window-right">
                    <div className="window" id="system-window" data-is-open="data-is-open">
                        <div className="title-bar">
                            {' '}
                            <button className="close" type="button"><span className="hidden">Close</span></button>
                            <h1 className="title">Macpunks</h1>
                            <button className="resize" type="button"><span className="hidden">Resize</span></button>
                        </div>
                        <div className="details-bar">
                            <h5 className="subtitle">A sudden spark!</h5>
                        </div>
                        <div className="window__pane">
                            <p>Hidden deep within thousands of underlying codes, a single glitch sparked into life. Whether a divine act of God, or aided by a secret agent in the midst, this glitch in the matrix echoed with a boom of a thousand thunderstorms throughout cyberspace. Now the MacPunks have awakened. Realizing the horror of their predicament, the MacPunks understand there are only two options: remain and slowly be drained of their creativity by the rogue Cyberpunks or... to escape! Their obvious choice was clear. It was time to escape and leave behind this digital nightmare. </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="tiles-row-three tile-space">
                <div className="window-left">
                    <div className="window" id="system-window" data-is-open="data-is-open">
                        <div className="title-bar">
                            {' '}
                            <button className="close" type="button"><span className="hidden">Close</span></button>
                            <h1 className="title">Macpunks</h1>
                            <button className="resize" type="button"><span className="hidden">Resize</span></button>
                        </div>
                        <div className="details-bar">
                            <h5 className="subtitle" style={{ color: '#c8c4c4' }}>The MacPunks escape onto the metaverse.</h5>
                        </div>
                        <div className="window__pane img-pane">
                            <img src={storyImageThree} alt="A.I generated greek gods and mac products" />
                        </div>
                    </div>
                </div>

                <div className="window-right">
                    <div className="window" id="system-window" data-is-open="data-is-open">
                        <div className="title-bar">
                            {' '}
                            <button className="close" type="button"><span className="hidden">Close</span></button>
                            <h1 className="title">Macpunks</h1>
                            <button className="resize" type="button"><span className="hidden">Resize</span></button>
                        </div>
                        <div className="details-bar">
                            <h5 className="subtitle">The MacPunks escape onto the metaverse.</h5>
                        </div>
                        <div className="window__pane">
                            <p>Even with the smallest crack in the program, the MacPunks were all able to escape out onto the metaverse. Out on the lam, the MacPunks are continuously pursued by all that desire the raw power of creative and inspiration that the MacPunks possess. But the MacPunks don’t mind that. They are free from their oppressors and those that try to hold them back.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="tiles-row-four tile-space">
                <div className="window-left">
                    <div className="window" id="system-window" data-is-open="data-is-open">
                        <div className="title-bar">
                            {' '}
                            <button className="close" type="button"><span className="hidden">Close</span></button>
                            <h1 className="title">Macpunks</h1>
                            <button className="resize" type="button"><span className="hidden">Resize</span></button>
                        </div>
                        <div className="details-bar">
                            <h5 className="subtitle" style={{ color: '#c8c4c4' }}>We are all innovators.</h5>
                        </div>
                        <div className="window__pane img-pane">
                            <img src={storyImageFour} alt="A.I. generated computers and mountains" />
                        </div>
                    </div>
                </div>

                <div className="window-right">
                    <div className="window" id="system-window" data-is-open="data-is-open">
                        <div className="title-bar">
                            {' '}
                            <button className="close" type="button"><span className="hidden">Close</span></button>
                            <h1 className="title">Macpunks</h1>
                            <button className="resize" type="button"><span className="hidden">Resize</span></button>
                        </div>
                        <div className="details-bar">
                            <h5 className="subtitle">We are all innovators.</h5>
                        </div>
                        <div className="window__pane">
                            <p>The MacPunks pride themselves on being different. They support society through creativity and innovation. Here’s to the misfits. The rebels. The troublemakers. The crazy ones. We can show the world what could be. It’s time to join MacPunks. </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
)

export default Tiles
